import { asSeconds, type Seconds } from "./types";

/** Минимальный шаг dt в миллисекундах (clamp). Защита от scroll/long frames. */
export const DT_CLAMP_MS = 50;

/** Данные одного тика игрового цикла. */
export interface Tick {
  dt: Seconds;
  elapsed: Seconds;
  frame: number;
}

/** Обёртка над performance.now() с clamping dt. */
export class Clock {
  private last = 0;
  private elapsedAccum: Seconds = asSeconds(0);
  private frameCount = 0;
  private started = false;

  /** Текущее значение performance.now(). */
  now(): number {
    return performance.now();
  }

  /** Сбрасывает накопленное время и счётчик кадров. */
  reset(): void {
    this.last = performance.now();
    this.elapsedAccum = asSeconds(0);
    this.frameCount = 0;
    this.started = true;
  }

  /** Вычисляет dt (clamped), накапливает elapsed, инкрементирует frame. */
  tick(now: number): Tick {
    if (!this.started) {
      this.last = now;
      this.started = true;
    }
    const rawDtMs = Math.min(now - this.last, DT_CLAMP_MS);
    this.last = now;
    const dt = asSeconds(rawDtMs / 1000);
    this.elapsedAccum = asSeconds((this.elapsedAccum as number) + (dt as number));
    this.frameCount += 1;
    return { dt, elapsed: this.elapsedAccum, frame: this.frameCount };
  }
}
